<template>
  <div class="page">
    <h1 class="title">404</h1>
    <h2 class="subtitle">Page not found</h2>
    <p class="explanation">Sorry, we can't seem to find the page you are looking for. Please use the navigation above to continue.</p>
  </div>
</template>

<script>
  export default {
    name: "PageNotFound"
  }
</script>

<style scoped lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Lato:400,900');
  .page {
    width: 100%;
    text-align: center;
    font-family: "Lato", sans-serif;
  }
  .title {
    font-size: 9.0em;
    color: lightgray;
    font-weight: 900;
  }
  .subtitle {
    font-size: 2.0em;
    color: #3c3c3c;
    font-weight: 900;
  }
  .explanation {
    font-size: 1.2em;
  }
</style>